/**
 * Generated by @openapi-codegen
 *
 * @version 1.0.0
 */
import * as reactQuery from 'app/src/shared/helpers/reactquery'
import { JoinstepsContext, useJoinstepsContext } from './joinsteps-context'
import type * as Fetcher from './joinsteps-fetcher'
import { joinstepsFetch } from './joinsteps-fetcher'
import type * as Schemas from './joinsteps-schemas'

export type JoinStepListPathParams = {
  templateBasePath: string
}

export type JoinStepListError = Fetcher.ErrorWrapper<{
  status: 400
  payload: {
    /**
     * Error type
     */
    type: string
    /**
     * HTTP status
     */
    status: number
    /**
     * Error message
     */
    title: string
    /**
     * Unique return code
     *
     * @format int32
     */
    rc?: number
  }
}>

export type JoinStepListVariables = {
  pathParams: JoinStepListPathParams
} & JoinstepsContext['fetcherOptions']

/**
 * Returns the list of the Join Steps
 */
export const fetchJoinStepList = (variables: JoinStepListVariables, signal?: AbortSignal) =>
  joinstepsFetch<Schemas.JoinSteps, JoinStepListError, undefined, {}, {}, JoinStepListPathParams>({
    url: '/{templateBasePath}/pages/joinsteps',
    method: 'get',
    ...variables,
    signal,
  })

/**
 * Returns the list of the Join Steps
 */
export const useJoinStepList = <TData = Schemas.JoinSteps>(
  variables: JoinStepListVariables,
  options?: Omit<reactQuery.UseQueryOptions<Schemas.JoinSteps, JoinStepListError, TData>, 'queryKey' | 'queryFn' | 'initialData'>,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } = useJoinstepsContext(options)
  return reactQuery.useQuery<Schemas.JoinSteps, JoinStepListError, TData>({
    queryKey: queryKeyFn({
      path: '/{templateBasePath}/pages/joinsteps',
      operationId: 'joinStepList',
      variables,
    }),
    queryFn: ({ signal }) => fetchJoinStepList({ ...fetcherOptions, ...variables }, signal),
    ...options,
    ...queryOptions,
  })
}

export type QueryOperation = {
  path: '/{templateBasePath}/pages/joinsteps'
  operationId: 'joinStepList'
  variables: JoinStepListVariables
}
